import { ingredientData } from '../data/ingredientData';

function normalizedCandidates(ingredient) {
  return [ingredient.name, ...(ingredient.alsoKnownAs || [])]
    .map((name) => name.toLowerCase().trim())
    .filter(Boolean);
}

function containsCandidate(label, candidate) {
  const escaped = candidate.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return new RegExp(`(^|[^a-z0-9])${escaped}($|[^a-z0-9])`, 'i').test(label);
}

export function findFlaggedIngredients(label) {
  const normalizedLabel = label.toLowerCase();
  return ingredientData
    .filter((ingredient) => normalizedCandidates(ingredient).some((candidate) => containsCandidate(normalizedLabel, candidate)))
    .sort((a, b) => a.name.localeCompare(b.name));
}
